import { camelize, translate } from '../format/string';
import locale from '../../locale';
export function createI18N(name) {
  var prefix = name ? camelize(name) + '.' : '';
  return function (path) {
    var message = locale.t(prefix + path) || locale.t(path);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return translate(message, args);
  };
}